import { FormHelperText } from '@mui/material'

import { EligibilityPicker } from './components/EligibilityPicker'

import { EligibilityPickerFieldProps } from './typings'

export function EligibilityPickerField(props: EligibilityPickerFieldProps) {
  const { label, info, testid, onChange, value, error } = props

  return (
    <EligibilityPicker
      onChange={onChange}
      value={value}
      label={label}
      testId={testid}
      messages={
        <>
          {!!error && <FormHelperText error>{error}</FormHelperText>}
          {!error && !!info && <FormHelperText>{info}</FormHelperText>}
        </>
      }
    />
  )
}
